

import { Button } from "@/components/ui/button";


interface CipherAlreadyCompletedProps {
  brocode: string;
  rank: string;
  onComplete: () => void;
  walletAddress?: string;
  debug?: boolean;
}

const CipherAlreadyCompleted = ({ 
  brocode, 
  rank, 
  onComplete, 
  walletAddress, 
  debug = false 
}: CipherAlreadyCompletedProps) => {
  return (
    <div className="max-w-2xl mx-auto p-8">
      <div className="text-center space-y-6">
        <div className="mb-8">
          <div className="inline-block bg-secondary rounded-full p-4 shadow-lg">
            <img 
              src="/lovable-uploads/clr_4.png" 
              alt="Bromentum Logo" 
              className="w-12 h-12 object-contain"
            />
          </div>
        </div>
        <h2 className="text-2xl font-patrick mb-4 text-tan">You've already completed your initiation, bro.</h2>
        <p className="text-xl text-tan">One shot only. The Swarm remembers.</p>
        <p className="text-xl mt-4 text-tan">Your BroCode: <span className="font-bold">{brocode}</span></p>
        <p className="text-lg mt-4 text-tan">Your rank: <span className="font-bold">{rank}</span></p>
        
        {/* Debug information - only shown when debug is true */}
        {debug && walletAddress && (
          <div className="mt-4 p-4 bg-navy-dark rounded-lg text-sm text-left">
            <p className="text-gray-300">Wallet Address: {walletAddress}</p>
          </div>
        )}
        
        <Button
          onClick={onComplete}
          className="bg-tan text-navy-dark hover:bg-tan-dark mt-6"
        >
          View Your Brotherhood Status
        </Button>
      </div>
    </div>
  );
};

export default CipherAlreadyCompleted;
